function formatMilliseconds(value: number): string {
  if (value < 1000) {
    return `${value}ms`;
  }

  if (value < 60_000) {
    return `${Math.round(value / 100) / 10}s`;
  }

  const minutes = Math.floor(value / 60_000);
  const seconds = Math.round((value % 60_000) / 1000);
  return `${minutes}m ${seconds}s`;
}

export function formatAdminDuration(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return "0s";
  }

  if (value < 0) {
    return "0s";
  }

  return formatMilliseconds(value);
}
